/** Человекочитаемые подписи вместо технических имён полей/API */

export function formatNumberRu(num) {
  if (num == null || num === '') return '';
  return Number(num).toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function formatStrategyLabel(campaign) {
  if (!campaign?.bidder_enabled) return 'Биддер выключен';
  if (campaign.strategy_type === 'target_cpc' && campaign.target_cpc) {
    return `По стоимости клика: ${formatNumberRu(campaign.target_cpc)} ₽`;
  }
  if (campaign.strategy_type === 'conversion_cost' && campaign.target_conversion_cost) {
    return `По стоимости конверсии: ${formatNumberRu(campaign.target_conversion_cost)} ₽`;
  }
  if (campaign.strategy_type === 'threshold_scout') {
    const t = campaign.target_conversion_cost;
    return t
      ? `Скаут порога: CPO ${formatNumberRu(t)} ₽`
      : 'Скаут порога';
  }
  if (campaign.strategy_type === 'drr' && campaign.target_drr) {
    return `По ДРР: ${formatNumberRu(campaign.target_drr)}%`;
  }
  return 'Стратегия не настроена';
}

export function formatAdPlacementLabel(adPlacement) {
  const p = String(adPlacement || '').toLowerCase();
  if (p === 'combined') return 'поиск + рекомендации';
  if (p === 'search') return 'поиск';
  if (p === 'recommendations') return 'рекомендации';
  return '';
}

export function formatArticleRef(nmId) {
  if (nmId == null || nmId === '' || Number(nmId) <= 0) return '';
  return `арт. ${nmId}`;
}

export function formatTargetTypeLabel(type) {
  if (type === 'article') return 'Артикул';
  if (type === 'keyword') return 'Ключевое слово';
  if (type === 'norm_query') return 'Поисковый кластер';
  return type ? String(type) : '—';
}

export const strategyTypeOptions = [
  { value: 'target_cpc', label: 'По стоимости клика' },
  { value: 'conversion_cost', label: 'По стоимости конверсии' },
  { value: 'threshold_scout', label: 'Скаут порога' },
  { value: 'drr', label: 'По ДРР' },
];
